var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewWindow = function SvgNewWindow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 4 8.4 9.4c-.6.6-.6 1.5 0 2.1.6.6 1.5.6 2.1 0L16 6.1v2.4c0 .8.7 1.5 1.5 1.5S19 9.3 19 8.5V1h-7.5c-.8 0-1.5.7-1.5 1.5S10.7 4 11.5 4h2.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.5C1 7.6 2.6 6 4.5 6H7c.8 0 1.5.7 1.5 1.5S7.8 9 7 9H4.5c-.3 0-.5.2-.5.5v6c0 .3.2.5.5.5h6c.3 0 .5-.2.5-.5v-2.4c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v2.4c0 1.9-1.6 3.5-3.5 3.5h-6C2.6 19 1 17.4 1 15.5v-6z"
  })));
};
export default SvgNewWindow;